//Super simple directives only for factorizing html code.

export function textsSelector() {
  return {
    restrict: 'E',
    scope: false,
    template: require('./textsSelector.html'),
  };
}

export function checkboxesSelector() {
  return {
    restrict: 'E',
    scope: false,
    template: require('./checkboxesSelector.html'),
  };
}

export function checkboxesWithChildrenSelector() {
  return {
    restrict: 'E',
    scope: false,
    template: require('./checkboxesWithChildrenSelector.html'),
  };
}

export function dayrangeSelector() {
  return {
    restrict: 'E',
    scope: false,
    template: require('./dayrangeSelector.html'),
  };
}
